import React from "react";
import GetAny from "utils/GetAny";
import TBBImage from "utils/TBBImage";
import TBBLink from "utils/TBBLink";

const FeaturedCard = ({ blok }) => {
  const post = blok.item ? GetAny([blok.item]) : GetAny([], "thoughts");
  return (
    <div className="relative my-12 overflow-hidden lg:my-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <TBBLink to={post[0]?.full_slug} className="group">
          <TBBImage
            image={post[0]?.content?.featured_image}
            className="w-full"
          />
          <h4 className="mt-8 max-w-[986px] text-[24px] leading-tight text-[#091DF3] md:mt-10 md:text-[28px] lg:mt-12 lg:text-[34px]">
            {post[0]?.name}
          </h4>
          <div className="relative mt-4 flex h-7 w-7 items-center justify-center rounded-full bg-[#F9DFE8] duration-300 group-hover:rotate-180 md:mt-6 md:h-9 md:w-9">
            <div className="absolute top-1/2 left-1/2 h-[16px] w-[3px] -translate-y-1/2 -translate-x-1/2 bg-[#091DF3] md:h-[20px] md:w-[3px]"></div>
            <div className="absolute top-1/2 left-1/2 h-[17px] w-[3px] -translate-y-1/2 -translate-x-1/2 rotate-90 bg-[#091DF3] md:h-[20px] md:w-[3px]"></div>
          </div>
        </TBBLink>
      </div>
    </div>
  );
};

export default FeaturedCard;
